import React from "react";
import { translate } from "../Services/translation";

const LanguageSelector = ({ languages }) => {
    return (
     <>
            {languages.length < 2 ? null : (
                <ul className="header__switch">
                    {languages.map(language => {
                        return (
                            <li 
                                className={
                                    language.selected
                                        ? "header__switch-item header__switch-item--active"
                                        : "header__switch-item"
                                }
                                key={language.value}>
                                <a href={language.url}>{language.text}</a>
                            </li>
                        );
                    })}
                    </ul>
                  
            ) }
        </>     
        )
                    
};

export default LanguageSelector;